import React, {Component} from "react";
import LunaComplete from "./LunaComplete";
import LunaSteps from "./LunaSteps";
import {Spinner} from "reactstrap";
import {FormattedMessage} from "react-intl";
import ErrorMessage from "../ErrorMessage";

const lunaLogo = require("../../resources/img/anywhere/luna_logo.svg");

interface Props {
    error: boolean;
    onRefresh: () => void;
    loading: boolean;
    pendingUserApproval: boolean;
    onCodeRequest: () => void;
    onSurveyAccess: () => void;
    onSurveySkip: () => void;
    onLunaAccess: () => void;
    betaUserApproved: boolean;
    accountLinked: boolean;
}

export class LunaCard extends Component<Props> {
    render(): JSX.Element {
        let contents: JSX.Element;

        if (this.props.loading) {
            contents = <Spinner style={{width: '5rem', height: '5rem'}} type="grow" color="light" />;
        } else if (this.props.error) {
            contents = (
                <ErrorMessage
                    message={<FormattedMessage id="message.error"/>}
                    onRefresh={this.props.onRefresh}
                />
            );
        } else {
            contents = <>
                <img src={lunaLogo} alt="Luna Logo"/>

                {this.props.accountLinked && <LunaComplete onLunaAccess={this.props.onLunaAccess} />}

                {
                    !this.props.accountLinked &&
                        <LunaSteps
                            loading={this.props.pendingUserApproval}
                            onCodeRequest={this.props.onCodeRequest}
                            onSurveyAccess={this.props.onSurveyAccess}
                            onSurveySkip={this.props.onSurveySkip}
                            betaUserApproved={this.props.betaUserApproved}
                        />
                }
            </>;
        }

        return (
            <div className="anywhereTab__cards__card luna">
                {contents}
            </div>
        );
    }
}